$(document).ready(function () {

  function hasBuckleSelector(container = document) {
    return $(container).find(".buckle-options-main").length > 0;
  }

  function initQuickCartWatcher() {
    const observer = new MutationObserver(function () {

      const $drawer = $("quick-buy-drawer");
      if (!$drawer.length) return;
      const $btn = $drawer.find("form[action='/cart/add'] button[type='submit']");
      if ($btn.length) {
        console.log("binding buckle events");
        console.log("Quick cart detected → running toggleCartButtons");
        toggleCartButtons();
        syncBuckleVariants();
        autoSelectMatchingBuckle();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initQuickCartWatcher();

  function getSelectedBuckleSize() {
    var variantId = $("form.shopify-product-form input[name='id']").val();
    console.log("variantIdvariantId: ",variantId);
    var variant = window.productVariants.find(v => v.id == variantId);
    if (!variant) return null;
    var sizeOptionIndex = -1;

    if (window.productData && window.productData.options) {
      sizeOptionIndex = window.productData.options.findIndex(
        option => option.toLowerCase() === "size"
      );
    }

    if (sizeOptionIndex === -1) return null;
    var sizeValue = variant["option" + (sizeOptionIndex + 1)];
    if (!sizeValue || sizeValue.indexOf("/") === -1) return null;
    return sizeValue.split("/")[1].trim();
  }

  function autoSelectMatchingBuckle() {
    var buckleSize = getSelectedBuckleSize();
    if (!buckleSize) return;
    console.log("Looking for buckle:", buckleSize);
    var $activeTab = $(".buckle-selector-tab-content-wrap.active");
    var $match = $activeTab.find('.buckle-option-variant[data-buckle-size="' + buckleSize + '"]').first();

    if (!$match.length) {
      console.warn("No buckle found for", buckleSize);
      return;
    }

    $activeTab.find(".buckle-option-variant").removeClass("active");
    $match.addClass("active");
    updatePrice();
    updateBuckleProperties();
    toggleCartButtons();
  }
  
  var bundleId,buckleId;
  let qty = 1;

  function findMatchingVariant(variants) {
    var buckleSize = getSelectedBuckleSize();
    if (!buckleSize) return null;
    return variants.find(function(v) {
      return (
        v.option1 === buckleSize ||
        v.option2 === buckleSize ||
        v.option3 === buckleSize
      );
    });
  }

  // "18mm" should match "18mm" as well as "18mm - Stainless Steel".
  function variantMatchesSize(v, size) {
    if (!size) return false;
    var wanted = String(size).trim().toLowerCase();
    return [v.option1, v.option2, v.option3].some(function (o) {
      if (typeof o !== "string") return false;
      var opt = o.trim().toLowerCase();
      return opt === wanted || new RegExp("^" + wanted.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "(?![0-9a-z])").test(opt);
    });
  }

  // Switch buckle tab; make sure the shown tab has a selection so the
  // "Selected Buckle" property always reflects what the customer sees.
  function activateBuckleTab(index) {
    $(".buckle-selector-tab").removeClass("active");
    $('.buckle-selector-tab[data-index="' + index + '"]').addClass("active");
    $(".buckle-selector-tab-content-wrap").removeClass("active").hide();
    var $wrap = $('.buckle-selector-tab-content-wrap[data-index="' + index + '"]').addClass("active").show();
    if (!$wrap.find(".buckle-option-variant.active:not([hidden])").length) {
      $wrap.find(".buckle-option-variant").removeClass("active");
      $wrap.find(".buckle-option-variant:not([hidden])").first().addClass("active");
    }
    updatePrice();
    updateBuckleProperties();
    toggleCartButtons();
  }

  function syncBuckleVariants() {
    var buckleSize = getSelectedBuckleSize();

    if (!buckleSize) {
      console.warn("No buckle size found");
      return;
    }

    console.log("Syncing buckle size:", buckleSize);

    $(".classic-buckle").each(function () {
      var $card = $(this);
      var productId = parseInt($card.attr("data-product-id"));
      var match = window.classicVariants.find(function (v) {
        return (
          v.productId === productId &&
          (
            v.option1 === buckleSize ||
            v.option2 === buckleSize ||
            v.option3 === buckleSize
          )
        );
      });

      if (!match) {
        console.warn("No classic variant found", productId, buckleSize);
        return;
      }

      $card.attr("data-id", match.id);
      $card.attr("data-variant-title", match.title);
      console.log("Classic updated:", productId, match.title, match.id);
    });

    /*
    * DEPLOYANT CLASPS (one card per configured clasp product)
    */
    var deployVariants = window.deploymentVariants || [];
    var $deployCards = $(".deployment-buckle");
    var visibleDeploy = 0;

    $deployCards.each(function () {
      var $card = $(this);
      var productId = parseInt($card.attr("data-product-id"));
      var candidates = deployVariants.filter(function (v) {
        // Legacy data (no productId) applies to every card.
        return (v.productId == null || v.productId === productId) && variantMatchesSize(v, buckleSize);
      });
      // Prefer the stainless steel finish when a clasp comes in several colours.
      var match = candidates.find(function (v) {
        return /stainless|steel|silver/i.test([v.option1, v.option2, v.option3, v.title].join(" "));
      }) || candidates[0];

      if (!match) {
        console.warn("No deployant clasp variant found", productId, buckleSize);
        $card.removeClass("active").attr("hidden", "hidden").removeAttr("data-id data-variant-title");
        return;
      }

      visibleDeploy++;
      $card.removeAttr("hidden");
      $card.attr("data-id", match.id);
      $card.attr("data-variant-title", match.title);
      $card.attr("data-buckle-price", match.price);
      console.log("Deployant updated:", productId, match.title, match.id);
    });

    // Hide the Deployant Clasp tab entirely when no clasp exists in this buckle width.
    var $deployTab = $('.buckle-selector-tab[data-index="2"]');
    if ($deployCards.length && visibleDeploy === 0) {
      $deployTab.attr("hidden", "hidden");
      if ($deployTab.hasClass("active")) {
        activateBuckleTab(1);
      }
    } else {
      $deployTab.removeAttr("hidden");
    }
    // Compact picker: with only one chip left there is nothing to choose, so hide the row.
    $(".buckle-selector-tab-container").each(function () {
      var visibleTabs = $(this).find(".buckle-selector-tab:not([hidden])").length;
      $(this).toggleClass("buckle-tabs-single", visibleTabs < 2);
    });
    updateBuckleSummary();

    /*
    * Update selected buckle title if active
    */
    var $active = $(".buckle-option-variant.active");
    if ($active.length) {
      var variantTitle = $active.attr("data-variant-title");
      if (variantTitle) {
        var productTitle = $active.find(".buckle-option-variant-title")
          .text().split(" - ")[0].trim();
        $active.attr("data-display-title",productTitle + " - " + variantTitle);
      }
    }
  }

  syncBuckleVariants();

  document.addEventListener("variant:change", function(event) {
    console.log("variant changed");
    var buckleSize = getSelectedBuckleSize();
    console.log("Selected buckle size:", buckleSize);
    syncBuckleVariants();
    var $active = $(".buckle-option-variant.active");
    if ($active.length) {
      updateBuckleProperties();
      updatePrice();
    }
    console.log("Active buckle after sync:",$active.attr("data-id"));
  });

  function toggleCartButtons() {
    if (!hasBuckleSelector()) return;
    var hasActive = $('.buckle-selector-tab-content-wrap.active .buckle-option-variant.active:not([hidden])').length > 0;
    var $addToCart = $('form[action="/cart/add"] button[type="submit"]');
    var $buyNow = $('.shopify-payment-button');

    // NEW selectors
    var $customBtn = $('button[is="custom-button"]');
    var $mobileBuyBtn = $('.mobile-only.mob-buy-btn .buy_strap_mob');
    if (hasActive) {
      // Enable Add to Cart
      $addToCart.prop('disabled', false).removeAttr('disabled').removeClass('disabled');
      // Enable Buy Now
      $buyNow.removeClass('disabled').removeAttr('disabled')
      .css({ 'pointer-events': 'auto', 'opacity': '1' });
      // Enable custom button
      $customBtn.prop('disabled', false).removeAttr('disabled').removeClass('disabled');

      // Enable mobile button
      $mobileBuyBtn.prop('disabled', false).removeAttr('disabled').removeClass('disabled')
      .css({ 'pointer-events': 'auto', 'opacity': '1' });

    } else {
      // Disable Add to Cart
      $addToCart.prop('disabled', true).attr('disabled', 'disabled').addClass('disabled');

      // Disable Buy Now
      $buyNow.addClass('disabled').attr('disabled', 'disabled')
      .css({ 'pointer-events': 'none', 'opacity': '0.5' });

      // Disable custom button
      $customBtn.prop('disabled', true).attr('disabled', 'disabled').addClass('disabled');

      // Disable mobile button
      $mobileBuyBtn.prop('disabled', true).attr('disabled', 'disabled').addClass('disabled')
      .css({ 'pointer-events': 'none', 'opacity': '0.5' });
    }
  }

  toggleCartButtons();

  buckleId = "buckle_" + Date.now();

  $(document).on("click", ".buckle-option-variant", function () {
    console.log("clciked");
    if (!hasBuckleSelector()) return;
    buckleId = "buckle_" + Date.now();
    var $parent = $(this).closest(".buckle-option-tab-content, .buckle-selector-tab-content-wrap");

    // Re-clicking the selected swatch keeps it selected (a buckle is always required).
    if ($(this).hasClass("active")) return;
    $parent.find(".buckle-option-variant").removeClass("active");
    $(this).addClass("active");

    updatePrice();
    updateBuckleProperties();
    toggleCartButtons();
  });

  function getVariantPriceFromForm(){
    var variantId = $("form.shopify-product-form input[name='id']").val();
    var variant = window.productVariants.find(v => v.id == variantId);
    console.log("variantform: ".variant);
    return variant ? variant.price : 0;
  }

  function updateQuantity(newQty) {
    qty = Math.max(1, parseInt(newQty) || 1);
    $(".quantity-selector__input").val(qty);
  }

  $(document).on('input', '.quantity-selector__input', function () {
    updateQuantity($(this).val());
  });

  $(document).on('click', '.quantity-selector__button', function () {
    var $input = $(".quantity-selector__input");
    var currentQty = parseInt($input.val()) || 1;

    if ($(this).attr('aria-label') === 'Increase quantity') {
      updateQuantity(currentQty);
    } else if ($(this).attr('aria-label') === 'Decrease quantity') {
      updateQuantity(currentQty - 1);
    }
  });

  function getCurrentQuantity() {
    return qty;
  }

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  // Delegated so tabs inside the quick-buy drawer (rendered later) work too.
  $(document).on('click', '.buckle-selector-tab', function () {
    activateBuckleTab($(this).data('index'));
  });

  function updatePrice(){
    var variantPrice = 0;

    if(window.currentVariant){
      variantPrice = window.currentVariant.price;
    } else {
      variantPrice = getVariantPriceFromForm();
    }
    console.log("variantPrice:", variantPrice);

    var $activeBuckle = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");

    var bucklePrice = $activeBuckle.length ? parseInt($activeBuckle.attr("data-buckle-price")) : 0;
    console.log("bucklePrice:", bucklePrice);
    var finalPrice = variantPrice + bucklePrice;
    console.log("finalPrice:", finalPrice);

    var formattedPrice = formatMoney(finalPrice, currencyFormat);
    console.log("formattedPrice: ",formattedPrice);

    $("price-list sale-price").html(formattedPrice);
  }

  // Compact picker: "Buckle: Polished" + "Included" / "+ $30" in the header line.
  function updateBuckleSummary(){
    $(".buckle-compact").each(function () {
      var $box = $(this);
      var fmt = (typeof currencyFormat !== 'undefined' && currencyFormat) || "";
      var moneyOf = function (cents) {
        return formatMoney(cents, fmt).replace(/<[^>]*>/g, '').replace(/\.00(?=\D|$)/, '').trim();
      };
      // Clasp chip shows the price of the clasp that fits the current buckle width.
      var $clasp = $box.find(".deployment-buckle:not([hidden])").first();
      var claspPrice = parseInt($clasp.attr("data-buckle-price")) || 0;
      $box.find('.buckle-selector-tab[data-index="2"] .buckle-tab-sub').text(claspPrice > 0 ? "+ " + moneyOf(claspPrice) : "");
      var $active = $box.find(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active:not([hidden])").first();
      var $name = $box.find(".buckle-selected-name");
      var $price = $box.find(".buckle-selected-price");
      if (!$active.length) { $name.text(""); $price.text(""); return; }
      var label = $.trim($active.find(".buckle-swatch-label").text()) || $.trim($active.attr("data-product-title") || "");
      if ($active.hasClass("deployment-buckle")) label += " clasp";
      var price = parseInt($active.attr("data-buckle-price")) || 0;
      $name.text(label);
      $price.text(price > 0 ? "+ " + moneyOf(price) : "Included");
    });
  }

  function updateBuckleProperties(){
    updateBuckleSummary();

    var $active = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");
    var $form = $("form.shopify-product-form");

    $form.find("input[name^='properties[Buckle']").remove();
    $form.find("input[name^='properties[Selected']").remove();
    $form.find("input[name='properties[_bundle]']").remove();

    if(!$active.length) return;

    var productTitle = $active.attr("data-product-title") || '';
    var variantTitle = $active.attr("data-variant-title") || '';
    var buckleTitle = productTitle;

    if (variantTitle) {
      buckleTitle += " - " + variantTitle;
    }

    var bucklePrice = parseInt($active.attr("data-buckle-price")) || 0;
    var formattedBucklePrice = formatMoney(bucklePrice, currencyFormat).replace(/<[^>]*>/g, '').trim();
    console.log("formattedBucklePrice: ",bucklePrice, formattedBucklePrice);
    console.log("Selected Buckletitle:", buckleTitle);

    $("<input>", {
      type: "hidden",
      name: "properties[Selected Buckle]",
      value: buckleTitle
    }).appendTo($form);

    if(bucklePrice > 0){
      $("<input>", {
        type: "hidden",
        name: "properties[Buckle Cost]",
        value: formattedBucklePrice
      }).appendTo($form);

      $("<input>", {
        type: "hidden",
        name: "properties[_bundle]",
        value: buckleId
      }).appendTo($form);
    }
  }

  function updateDrawer(cart){
    console.log("Updating cart drawer");
    document.dispatchEvent(
      new CustomEvent("cart:change", { detail: { cart: cart } })
    );
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  $(document).on("submit", "form.shopify-product-form", function () {

    var $form = $(this);
    var $active = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");
    if(!$active.length) return;

    var bucklePrice = parseInt($active.attr("data-buckle-price")) || 0;
    if(bucklePrice <= 0) return;

    // Get the current qty value
    var currentQty = getCurrentQuantity();

    // Example log, replace with your logic
    console.log('Current quantity is:', currentQty);
    console.log("Submitting buckle variant:", $active.attr("data-id"));
    var buckleVariantId = parseInt($active.attr("data-id"));

    // wait until theme confirms cart change (main product added)
    document.addEventListener("cart:change", function addBuckleOnce(){

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: buckleVariantId,
          quantity: currentQty,
          properties: {
            "_installed": "Yes",
            "Installed": "Yes",
            "_bundle": buckleId
          }
        })
      })
      .then(() => fetch('/cart.js')).then(res => res.json()).then(cart => {
        document.dispatchEvent(
          new CustomEvent("cart:change", { detail: { cart: cart } })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      });

      // ensure it runs only once
      document.removeEventListener("cart:change", addBuckleOnce);

    });
  });

  $(document).on("click", ".remove_bundle", function(e){
    e.preventDefault();
    console.log("Bundle remove clicked");

    var $row = $(this).closest(".cart-item, line-item");
    var bundleId = $row.data("bundle");
    console.log("Bundle ID:", bundleId);

    if(!bundleId){
      console.log("No bundle id found");
      return;
    }

    console.log("Fetching cart");

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        console.log("Cart loaded:", cart);
        var updates = {};
        cart.items.forEach(function(item){
          if(item.properties && item.properties._bundle === bundleId){
            console.log("Marking item for removal:", item.key);
            updates[item.key] = 0;
          }
        });

        console.log("Updates object:", updates);

        if(Object.keys(updates).length === 0){
          console.log("No bundle items found");
          return;
        }

        console.log("Sending batch removal");

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            updates: updates
          })
        });

      })
      .then(res => res.json())
      .then(cart => {

        console.log("Final cart after bundle removal:", cart);
        if(window.location.pathname === "/cart"){
          console.log("Reloading cart page");
          location.reload();
      }else{
        console.log("Updating cart drawer");
        document.dispatchEvent(
          new CustomEvent("cart:change", { detail: { cart: cart } })
        );

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        if(typeof updateDrawer === "function"){
          updateDrawer(cart);
        }
      }
    })
    .catch(err => {
      console.error("Bundle removal failed:", err);
    });

  });

  $(document).on('click', 'x-listbox button', function() {
    if ($('sold-out-badge.badge--sold-out').is('[hidden]')) {
      $('.availability_badge.mobile_avail_badge p').text('Available');
    } else {
      $('.availability_badge.mobile_avail_badge p').text('Sold Out');
    }
  });

  // Main slider
  $('.mobile-gallery-slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true,
    asNavFor: '.media-thumbs-list',
    nextArrow: '<div class="slide-arrow next-arr-slide"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.97415 5.75045L0.781874 10.6977C0.695239 10.7803 0.580137 10.8264 0.460443 10.8264C0.340749 10.8264 0.225648 10.7803 0.139013 10.6977L0.133422 10.6921C0.0912776 10.6521 0.0577183 10.6039 0.0347862 10.5505C0.0118542 10.497 2.81334e-05 10.4395 2.81334e-05 10.3814C2.81334e-05 10.3233 0.0118542 10.2657 0.0347862 10.2123C0.0577183 10.1589 0.0912776 10.1107 0.133422 10.0707L5.0229 5.41225L0.133422 0.755695C0.0912776 0.715658 0.0577183 0.667465 0.0347862 0.614049C0.0118542 0.560633 2.81334e-05 0.503109 2.81334e-05 0.444979C2.81334e-05 0.386848 0.0118542 0.329326 0.0347862 0.275909C0.0577183 0.222493 0.0912776 0.174299 0.133422 0.134262L0.139013 0.128672C0.225648 0.0460825 0.340749 1.04904e-05 0.460443 1.04904e-05C0.580137 1.04904e-05 0.695239 0.0460825 0.781874 0.128672L5.97415 5.07591C6.01981 5.11942 6.05617 5.17175 6.081 5.22972C6.10584 5.2877 6.11865 5.35011 6.11865 5.41318C6.11865 5.47625 6.10584 5.53867 6.081 5.59664C6.05617 5.65462 6.01981 5.70695 5.97415 5.75045Z" fill="black"/></svg></div>',
    prevArrow: '<div class="slide-arrow prev-arr-slide"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.144504 5.75045L5.33678 10.6977C5.42341 10.7803 5.53852 10.8264 5.65821 10.8264C5.7779 10.8264 5.893 10.7803 5.97964 10.6977L5.98523 10.6921C6.02737 10.6521 6.06093 10.6039 6.08387 10.5505C6.1068 10.497 6.11862 10.4395 6.11862 10.3814C6.11862 10.3233 6.1068 10.2657 6.08387 10.2123C6.06093 10.1589 6.02737 10.1107 5.98523 10.0707L1.09575 5.41225L5.98523 0.755695C6.02737 0.715658 6.06093 0.667465 6.08387 0.614049C6.1068 0.560633 6.11862 0.50311 6.11862 0.444979C6.11862 0.386848 6.1068 0.329326 6.08387 0.275909C6.06093 0.222493 6.02737 0.1743 5.98523 0.134262L5.97964 0.128672C5.893 0.0460835 5.7779 1.04904e-05 5.65821 1.04904e-05C5.53852 1.04904e-05 5.42341 0.0460835 5.33678 0.128672L0.144504 5.07591C0.0988405 5.11942 0.062487 5.17175 0.0376476 5.22972C0.0128082 5.2877 0 5.35011 0 5.41318C0 5.47625 0.0128082 5.53867 0.0376476 5.59664C0.062487 5.65462 0.0988405 5.70695 0.144504 5.75045Z" fill="black"/></svg></div>'
  });

  // Thumbnail navigation
  $('.media-thumbs-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.mobile-gallery-slick',
    focusOnSelect: true,
    arrows: false,
    dots:false,
    infinite: true
  });

  $('.multi-column.mob-mode').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    nextArrow: '<div class="slide-arrow next-arr-slide"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.97415 5.75045L0.781874 10.6977C0.695239 10.7803 0.580137 10.8264 0.460443 10.8264C0.340749 10.8264 0.225648 10.7803 0.139013 10.6977L0.133422 10.6921C0.0912776 10.6521 0.0577183 10.6039 0.0347862 10.5505C0.0118542 10.497 2.81334e-05 10.4395 2.81334e-05 10.3814C2.81334e-05 10.3233 0.0118542 10.2657 0.0347862 10.2123C0.0577183 10.1589 0.0912776 10.1107 0.133422 10.0707L5.0229 5.41225L0.133422 0.755695C0.0912776 0.715658 0.0577183 0.667465 0.0347862 0.614049C0.0118542 0.560633 2.81334e-05 0.503109 2.81334e-05 0.444979C2.81334e-05 0.386848 0.0118542 0.329326 0.0347862 0.275909C0.0577183 0.222493 0.0912776 0.174299 0.133422 0.134262L0.139013 0.128672C0.225648 0.0460825 0.340749 1.04904e-05 0.460443 1.04904e-05C0.580137 1.04904e-05 0.695239 0.0460825 0.781874 0.128672L5.97415 5.07591C6.01981 5.11942 6.05617 5.17175 6.081 5.22972C6.10584 5.2877 6.11865 5.35011 6.11865 5.41318C6.11865 5.47625 6.10584 5.53867 6.081 5.59664C6.05617 5.65462 6.01981 5.70695 5.97415 5.75045Z" fill="black"/></svg></div>',
    prevArrow: '<div class="slide-arrow prev-arr-slide"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.144504 5.75045L5.33678 10.6977C5.42341 10.7803 5.53852 10.8264 5.65821 10.8264C5.7779 10.8264 5.893 10.7803 5.97964 10.6977L5.98523 10.6921C6.02737 10.6521 6.06093 10.6039 6.08387 10.5505C6.1068 10.497 6.11862 10.4395 6.11862 10.3814C6.11862 10.3233 6.1068 10.2657 6.08387 10.2123C6.06093 10.1589 6.02737 10.1107 5.98523 10.0707L1.09575 5.41225L5.98523 0.755695C6.02737 0.715658 6.06093 0.667465 6.08387 0.614049C6.1068 0.560633 6.11862 0.50311 6.11862 0.444979C6.11862 0.386848 6.1068 0.329326 6.08387 0.275909C6.06093 0.222493 6.02737 0.1743 5.98523 0.134262L5.97964 0.128672C5.893 0.0460835 5.7779 1.04904e-05 5.65821 1.04904e-05C5.53852 1.04904e-05 5.42341 0.0460835 5.33678 0.128672L0.144504 5.07591C0.0988405 5.11942 0.062487 5.17175 0.0376476 5.22972C0.0128082 5.2877 0 5.35011 0 5.41318C0 5.47625 0.0128082 5.53867 0.0376476 5.59664C0.062487 5.65462 0.0988405 5.70695 0.144504 5.75045Z" fill="black"/></svg></div>'
  });

  var $btn = $('.buy_strap_mob');

  function getVariantFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function updateVariantId() {
    var currentVariant = getVariantFromUrl();
    if (currentVariant) {
      $btn.attr('var_id', currentVariant);
    }
  }

  updateVariantId();

  $(document).on('variant:change', function (evt) {
    if (evt.detail && evt.detail.variant) {
      $btn.attr('var_id', evt.detail.variant.id);
    } else {
      updateVariantId();
    }
  });

  let lastUrl = location.href;
  setInterval(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      updateVariantId();
    }
  }, 500);

  $btn.on('click', function (e) {
    e.preventDefault();

    var variant_id = $(this).attr('var_id');
    if (!variant_id) {
      alert('Please select a product option first.');
      return;
    }

    // Capture custom options
    var stitchingOption = $('#stitching-hidden').val();
    var springOption = $('#spring-hidden').val();
    var customNotes = $('#custom-notes').val();

    var properties = {};
    if (stitchingOption) {
      properties['Stitching Colour'] = stitchingOption;
    }
    if (springOption) {
      properties['Spring Bar'] = springOption;
    }
    if (customNotes) {
      properties['Notes'] = customNotes;
    }

    // Capture the selected buckle (ready-to-wear buckle selector), mirroring the
    // desktop flow in updateBuckleProperties() / the form submit handler.
    var $activeBuckle = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");

    // The buckle is required on RTW products, so block checkout if none is chosen.
    if (hasBuckleSelector() && !$activeBuckle.length) {
      alert('Please select a buckle option first.');
      return;
    }

    var buckleVariantId = 0;
    var bucklePrice = 0;
    var mobileBuckleId = null;

    if ($activeBuckle.length) {
      var buckleProductTitle = $activeBuckle.attr('data-product-title') || '';
      var buckleVariantTitle = $activeBuckle.attr('data-variant-title') || '';
      var buckleTitle = buckleProductTitle;
      if (buckleVariantTitle) {
        buckleTitle += ' - ' + buckleVariantTitle;
      }
      properties['Selected Buckle'] = buckleTitle;

      bucklePrice = parseInt($activeBuckle.attr('data-buckle-price')) || 0;
      buckleVariantId = parseInt($activeBuckle.attr('data-id')) || 0;

      // Paid buckles are added as a separate bundled line item.
      if (bucklePrice > 0 && buckleVariantId) {
        mobileBuckleId = 'buckle_' + Date.now();
        properties['_bundle'] = mobileBuckleId;
      }
    }

    // Add the strap to cart with custom + buckle properties
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variant_id,
        quantity: 1,
        properties: properties
      },
      dataType: 'json',
      success: function() {
        // For paid buckles, add the buckle as its own bundled line item
        // before heading to checkout.
        if (bucklePrice > 0 && buckleVariantId && mobileBuckleId) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: buckleVariantId,
              quantity: 1,
              properties: {
                '_installed': 'Yes',
                'Installed': 'Yes',
                '_bundle': mobileBuckleId
              }
            },
            dataType: 'json',
            complete: function() {
              window.location.href = '/checkout';
            }
          });
        } else {
          window.location.href = '/checkout';
        }
      },
      error: function (xhr) {
        console.error('Add to cart failed:', xhr);
      }
    });
  });

});